import { I18n } from '@calendly/i18n'

import { BaseNotificationSection } from '../base_notification_section'

export const EmailCancellationSection = ({ eventType }) => (
  <BaseNotificationSection
    kind="invitee_cancellation"
    eventType={{ ...eventType, notification_type: 'email' }}
    skipDirtyCheck={eventType.notification_type !== 'email'}
    description={I18n.t('publisher.event_type_editor.sections.communications.invitation_cancellation.description')}
  />
)
